import { render, staticRenderFns } from "./IconSvgCompTIAAppUsers.vue?vue&type=template&id=3b65bef6&scoped=true&"
import script from "./IconSvgCompTIAAppUsers.vue?vue&type=script&lang=js&"
export * from "./IconSvgCompTIAAppUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b65bef6",
  null
  
)

export default component.exports